import React, {useCallback, useMemo, useState} from "react";
import {Tabs} from "antd";
import {useHistory, useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {APPLICATION_TYPES} from "constants/application";
import {ApplicationList} from "./list/ApplicationList";
import {buildQueryParams, defaultFilters} from "./list/applicationQuery";

export const ApplicationsPage = () => {
    const {t} = useTranslation(["applications"]);
    const stores = useStore();
    const history = useHistory();
    const location = useLocation();
    const canViewAgency = stores.meStore.checkRole("agencyApplicationView");

    const requestedTab = new URLSearchParams(location.search).get("tab");
    const activeTab =
        requestedTab === APPLICATION_TYPES.agency && canViewAgency
            ? APPLICATION_TYPES.agency
            : APPLICATION_TYPES.company;

    const [filtersByType, setFiltersByType] = useState({
        [APPLICATION_TYPES.company]: defaultFilters,
        [APPLICATION_TYPES.agency]: defaultFilters
    });
    const filters = filtersByType[activeTab];
    const setFilters = useCallback(
        update =>
            setFiltersByType(previous => ({...previous, [activeTab]: update(previous[activeTab])})),
        [activeTab]
    );
    const queryParams = useMemo(() => buildQueryParams(filters), [filters]);

    // Her sekmenin sayısı yalnızca kendi filtreleriyle hesaplanır; sayfalama sayıyı etkilemez
    const countParams = useMemo(
        () =>
            Object.fromEntries(
                Object.values(APPLICATION_TYPES).map(type => {
                    const {skip, limit, ...params} = buildQueryParams(filtersByType[type]);
                    return [type, params];
                })
            ),
        [filtersByType]
    );
    const [, counts] = useFetch({
        fetchFn: stores.applicationStore.getApplicationCounts.bind(null, countParams),
        defaultDataValue: {},
        dependencies: [JSON.stringify(countParams)]
    });

    const tabLabel = type =>
        `${t(`tabs.${type}`, {ns: "applications"})} (${counts?.data?.[type] ?? 0})`;

    return (
        <div style={{padding: "24px"}}>
            <h2>{t("title", {ns: "applications"})}</h2>
            <Tabs
                activeKey={activeTab}
                onChange={tab => history.replace(`/applications?tab=${tab}`)}
                type="card"
            >
                <Tabs.TabPane key={APPLICATION_TYPES.company} tab={tabLabel("company")} />
                {canViewAgency ? (
                    <Tabs.TabPane key={APPLICATION_TYPES.agency} tab={tabLabel("agency")} />
                ) : null}
            </Tabs>
            <ApplicationList
                key={activeTab}
                type={activeTab}
                filters={filters}
                queryParams={queryParams}
                setFilters={setFilters}
            />
        </div>
    );
};
